define([], function () {
    return class {
        constructor() {
            this.xhrs = [];
            this.aborted = false;
            this.intervalTime = 3000;
            this.timeId = null;
        }
        start(onError) {
             this.onError = onError;
             this.aborted = false;
        }
        addXHR(xhr) {
            xhr.timeout = 30000;
            xhr.ontimeout = (e) => {
                console.log("timeout abort");
                this.abort();
            };
            this.xhrs.push(xhr);
        }
        interval(request) {
            request();
            clearInterval(this.timeId);
            this.timeId = setInterval(()=>{
                request();
            },this.intervalTime);
        }
        abort(result) {
            if ( (!result || !result.success) && this.onError) {
                this.onError()
            }
            clearInterval(this.timeId);
            this.aborted = true;
            this.xhrs.forEach(r=>r.abort() );
        }
    }
});
